module.exports = __webpack_public_path__ + "img/logo45.c17d2c74.png";